// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"6f0ddd64","171":"6709052a","453":"d855a71b"}[chunkId] + ".chunk.js";
};